import React from 'react';
import {
  RiseOutlined,
  DollarCircleOutlined,
  BankOutlined,
  FileTextOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons';

const FEATURES = [
  { icon: <RiseOutlined />, text: 'Live gold & silver rates with LTV tracking' },
  {
    icon: <DollarCircleOutlined />,
    text: 'Loan, interest & overdue management',
  },
  { icon: <BankOutlined />, text: 'Bank pledge and recovery tracking' },
  { icon: <FileTextOutlined />, text: 'Detailed reports and ledger' },
];

// Left-side marketing panel shared by the sign-in, sign-up and forgot-password pages.
const AuthHero: React.FC = () => (
  <>
    <section className="hero-copy">
      <h1>
        Run your <em>gold loan business</em> with confidence
      </h1>
      <p className="hero-sub">
        Track loans, pledged gold, interest, bank pledges and recovery — all in
        one place.
      </p>

      <ul className="hero-features">
        {FEATURES.map((feature) => (
          <li key={feature.text}>
            <span className="feature-icon">{feature.icon}</span>
            {feature.text}
          </li>
        ))}
      </ul>

      <p className="hero-foot">
        <SafetyCertificateOutlined /> Secure • Reliable • Built for gold finance
        businesses
      </p>
    </section>
  </>
);

export default AuthHero;
